import { render, staticRenderFns } from "./AddGoods.vue?vue&type=template&id=a237e8de&scoped=true&"
import script from "./AddGoods.vue?vue&type=script&lang=ts&"
export * from "./AddGoods.vue?vue&type=script&lang=ts&"
import style0 from "./AddGoods.vue?vue&type=style&index=0&id=a237e8de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a237e8de",
  null
  
)

export default component.exports